import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MessagesService } from './messages.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { AlertComponent } from "../../../alert/alert.component";
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";
import { UserService } from '../services/user.service';

interface DeleteObjectAttributes {
  index: number;
  idMessage: number;
}


@Component({
  selector: 'app-messages',
  standalone: true,
  imports: [MatIconModule, CommonModule, ReactiveFormsModule, FormsModule, PickerComponent, AlertComponent, LoadingModalComponent],
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  providers: [MessagesService, UserService]
})
export class MessagesComponent implements OnInit {
  //Variaveis de loading e alertas
  @ViewChild(AlertComponent) alertComponent !: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent !: LoadingModalComponent;


  //Variaveis para listagem das mensagens cadastradas
  public listMessages!: Array<any>;
  public mensagensLiberadas!: number;
  public mensagensCadastradas!: number;

  //Variaveis do modal de cadastrar nova mensagem
  public modalNewMessage: boolean = false;
  public text: string = '';
  public isEmojiPickerVisible: boolean = false;
  public formMessage: FormGroup;

  //Variaveis para editar uma mensagem
  public modalEditMessage: boolean = false;
  public messageSelected!: any;
  public formEditMessage!: FormGroup;
  public messageEdit!: string;

  //Variaveis para o modal de deletar mensagem
  public modalDeleteMessage: boolean = false;
  public selectedIdMessageDelete!: DeleteObjectAttributes;

  constructor(private messagesService: MessagesService, private userService: UserService, private fb: FormBuilder) {
    this.formMessage = this.fb.group({
      title: ['', [Validators.required]],
      text: ['', [Validators.required]]
    });


  }



  ngOnInit() {
    this.listConfigs();
    this.getMessages();

  }

  public listConfigs() {
    this.userService.getConfigUser().subscribe((response: any) => {
      this.mensagensLiberadas = response.configUser.quantidadeMensagem
    }, (error: any) => {
      console.log(error);
    })
  }

  public getMessages() {
    this.messagesService.getMessages()
      .subscribe((messages: any) => {
        this.listMessages = messages.messages;
        this.mensagensCadastradas = this.listMessages.length;
      }, (error) => {
        console.error('Erro ao obter mensagens:', error);
      });
  }

  public reloadData() {
    this.listConfigs();
    this.getMessages();
  }

  trackById(index: number, item: any): number {
    return index;
  }

  //Funcoes para o modal
  public openModalNewMessage() {
    this.modalNewMessage = true;
  }

  public closeModalNewMessage() {
    this.formMessage.patchValue({ title: '', text: '' });
    this.modalNewMessage = false;
  }



  public addEmoji(event: any) {
    // Garante que você está acessando o valor correto
    console.log(event.emoji.native);
    const emoji = event.emoji?.native; // Verifica se "native" existe
    if (emoji) {
      if (this.text === '') {
        this.text = emoji;
      } else {
        this.text += emoji; // Adiciona o emoji ao campo de texto
      }

    } else {
      console.log(emoji);
    }
  }

  // Fecha o seletor ao clicar fora
  @HostListener('document:click', ['$event'])
  closeEmojiPicker(event: MouseEvent) {
    this.isEmojiPickerVisible = false;
  }


  public toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.isEmojiPickerVisible = !this.isEmojiPickerVisible;
  }

  public addRefMessage(ref: Event) {
    const referencia = ref.target as HTMLSelectElement;
    this.text += `[${referencia.value}]`;
  }

  public cadastrarMensagem() {
    this.loadingComponent.activeLoading();



    this.messagesService.addMessage(this.formMessage.value).subscribe((response: any) => {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert('Mensagem cadastrada com sucesso!', 'success');
      this.listMessages.push({ title: this.formMessage.value.title, message: this.formMessage.value.text });
      this.closeModalNewMessage();

      // Realiza a requisição para buscar a lista em segundo plano após o cadastro da mensagem
      this.messagesService.getMessages().subscribe((responseMessages: any) => {
        this.listMessages = responseMessages.messages;
      }, (error: any) => {
        console.log(error);
        this.alertComponent.showAlert(`Erro ao buscar a lista de mensagens, ${error.error.status}`, 'error');
      });
    }, (error: any) => {
      console.log(error);
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao cadastrar mensagem, ${error.error.status}`, 'error');
    });
  }

  //Funcoes para o modal de Editar Mensagem

  public openModalEditMessage(message: any) {
    this.messageEdit = message.text;
    this.formEditMessage = this.fb.group({
      idmessage: [message.idmessage, [Validators.required]],
      title: [message.title, [Validators.required]],
      message: [message.message, [Validators.required]]
    });

    this.modalEditMessage = true;
  }

  public closeModalEditMessage() {
    this.modalEditMessage = false;
  }

  public editarMensagem() {
    this.loadingComponent.activeLoading();
    this.messagesService.updateMessage(this.formEditMessage.value).subscribe((response: any) => {
      this.alertComponent.showAlert('Mensagem editada com sucesso', 'success');
      this.reloadData();
      this.loadingComponent.inactiveLoading();
      this.closeModalEditMessage();
    }, (error: any) => {
      this.alertComponent.showAlert(`Erro ao tentar editar mensagem: ${error.error.status}`, 'error');
    });
  }

  public addEmojiEditForm(event: any) {
    // Garante que você está acessando o valor correto

    const emoji = event.emoji?.native; // Verifica se "native" existe
    if (emoji) {
      if (this.formEditMessage.value.text === '') {
        this.formEditMessage.patchValue({
          text: emoji
        });
      } else {
        this.formEditMessage.patchValue({
          text: this.formEditMessage.value.text + emoji
        })

        // this.formEditMessage.value.text += emoji; // Adiciona o emoji ao campo de texto
      }

    } else {
      console.log(emoji);
    }
  }

  public addRefMessageEdit(ref: Event) {
    const referencia = ref.target as HTMLSelectElement;
    this.formEditMessage.patchValue({
      message: this.formEditMessage.value.message +  `[${referencia.value}]`
    });
  }

  //Funcoes para deletar mensagem
  public openModalDeleteMessage(index: number){
    this.modalDeleteMessage = true;
    this.selectedIdMessageDelete = {
      index: index,
      idMessage: this.listMessages[index].idmessage
    }
  }
  public closeModalDeleteMessage(){
    this.modalDeleteMessage = false;
    
  }

  public deleteMessage(){
    this.loadingComponent.activeLoading();
    this.messagesService.deleteMessage(this.selectedIdMessageDelete.idMessage).subscribe((response: any)=> {
      this.alertComponent.showAlert('Mensagem deletada com sucesso!', 'success');
      this.loadingComponent.inactiveLoading();

      this.listMessages.splice(this.selectedIdMessageDelete.index,1);
      this.closeModalDeleteMessage();

      //Reprocessar a requisicao de listagem em segundo plano
      this.reloadData();
    } ,(error: any )=> {
      this.alertComponent.showAlert(`Erro ao deletar mensagem: ${error.error.status}`);
    })
  }

}
